/* global process */

// API Configuration
export const WEB_APP_URL: string = process.env.WEB_APP_URL!;
export const API_URL: string = WEB_APP_URL + '/api/v1';
export const CHAT_APP_URL: string = process.env.CHAT_APP_URL || WEB_APP_URL;
export const DEBUG_MODE: boolean = process.env.DEBUG_MODE === 'true' || false;

// Token caching - Tokens expire in 1 hour, cache for 50min to be safe
export const TOKEN_CACHE_DURATION_MS = 50 * 60 * 1000; // 50 minutes in milliseconds

// Time Conversions
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 3600;
export const MS_PER_SECOND = 1000;

// Font Configuration
export const MIN_FONT_SIZE = 1;
export const MAX_FONT_SIZE = 1638; // Office maximum font size
export const DEFAULT_FONT_COLOR = "#000000";

// Theme Colors (Fluent UI / Office)
export const COLORS = {
  PRIMARY_BLUE: "#0078d4",
  DANGER_RED: "#d13438",
  WARNING_YELLOW: "#856404",
  WARNING_YELLOW_DARK: "#6c5401",
  BLACK: "#000000",
  DARK_GRAY: "#434343",
  GRAY: "#666666",
  LIGHT_GRAY: "#999999",
  WHITE: "#FFFFFF",
} as const;

// Office Requirements
export const MIN_OFFICE_VERSION = "2021"; // Minimum Office version required
